import {React} from 'common'
import {Page, PageContent, Spacer} from 'components/Page'
import ResetPasswordForm from 'components/Welcome/ResetPasswordForm'
import AlreadyRegisteredRow from 'components/Welcome/AlreadyRegisteredRow'
import ContinueToLogin from 'components/Welcome/ContinueToLogin'
import useForgotPassword from 'logic/Welcome/useForgotPassword'
import {
    FormActionButton,
    FormCard,
    FormErrorMessage,
    FormWrapper,
} from 'components/Control/Form'

const ForgotPassword = () => {
    const {
        submit,
        formControl,
        formErrors,
        translate,
        successMessage,
        responseError,
    } = useForgotPassword()

    if (successMessage) {
        return <ContinueToLogin message={successMessage} />
    }

    return (
        <Page noHeader noDrawer>
            <PageContent centered>
                <FormCard style={{width: 400}}>
                    <FormWrapper onSubmit={submit}>
                        <ResetPasswordForm
                            translate={translate}
                            control={formControl}
                            errors={formErrors}
                        />
                        <Spacer h={10} />
                        <FormActionButton onClick={submit} variant="contained">
                            {translate('resetEmail')}
                        </FormActionButton>
                        <FormErrorMessage errorMessage={responseError} />
                    </FormWrapper>
                    <AlreadyRegisteredRow />
                </FormCard>
            </PageContent>
        </Page>
    )
}

export default ForgotPassword
